interface ValueValidationParams {
    ltp: number;
    value: number;
    property: string;
    volume: number;
    averageTradePrice: number;
  }

  export const deriveCondition = (
    property: string,
    value: number,
    ltp: number,
    averageTradePrice?: number,
  ): "GE" | "LE" => {
    if (property === "VOLUME") return "GE";
    if (property === "AVGPRICE" && averageTradePrice !== undefined) {
      return value >= averageTradePrice ? "GE" : "LE";
    }
    return value >= ltp ? "GE" : "LE";
  };
  
  export const valueValidation = ({ ltp, value, property, volume, averageTradePrice }: ValueValidationParams): string => {
    if (!value) return '';
  
    if (property === 'VOLUME') {
      return volume >= value ? `Volume must be > ${volume}` : '';
    }

    if (property === 'AVGPRICE') {
      return value === averageTradePrice
        ? `Value must be different from average trade price ${averageTradePrice}`
        : '';
    }

    if (value === ltp) {
      return `Value must be different from current price ${ltp}`;
    }
  
    return '';
  };
